export default "__VITE_ASSET__B5Yip7U0__"